import { arrayOf, normalize } from 'normalizr'

import { slotSchema } from './slots'

export const strongholdSchema = {
    slots: arrayOf(slotSchema),
}

export default function normalizeStronghold(strongholdInfo) {
    const { entities } = normalize(strongholdInfo, strongholdSchema)
    return entities
}



// WEBPACK FOOTER //
// ./state/schemas/stronghold.js